const Color = {

    // FIELDS
    "name": "الاسم",
    "color_code": "رمز اللون",
    "search": "بحث",

    // PAGE HEADER
    "color": "لون",

    // ERROR
    "error_name": "أدخل الاسم",
    "error_color": "أدخل رمز اللون",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_color": "رمز اللون",
}

export default Color;